import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ModalReceiptComponent } from '../pages/feed/extract/modal-receipt/modal-receipt.component';
import { ModalMoreComponent } from '../pages/feed/partners/modal-more/modal-more.component';
import { ModalReceiveLinkComponent } from '../pages/feed/receive/modal-receive-link/modal-receive-link.component';
import { ModalCashbackInfoComponent } from '../pages/signup-company/modal/signup-company-configs/modal-cashback-info/modal-cashback-info.component';
import { SignupCompanyConfigsComponent } from '../pages/signup-company/modal/signup-company-configs/signup-company-configs.component';
import { SignupCompanyDataComponent } from '../pages/signup-company/modal/signup-company-data/signup-company-data.component';
import { ModalDetailsIndicatedComponent } from '../pages/wallet/modal-details-indicated/modal-details-indicated.component';
import { PipesModule } from '../pipes/pipes.module';
import { CurrencyModule } from './../directive/currency.module';
import { ModalCashbackComponent } from './../pages/feed/cashback/modal-cashback/modal-cashback.component';
import { ModalChargeAndPayComponent } from './../pages/feed/pay/modal-charge-and-pay/modal-charge-and-pay.component';
import { ModalPayAddValueComponent } from './../pages/feed/pay/modal-pay-add-value/modal-pay-add-value.component';
import { ModalReceiveBankComponent } from './../pages/feed/receive/modal-receive-bank/modal-receive-bank.component';
import { ModalReceiveColappComponent } from './../pages/feed/receive/modal-receive-colapp/modal-receive-colapp.component';
import { ModalReceiveTotemComponent } from './../pages/feed/receive/modal-receive-totem/modal-receive-totem.component';
import { ModalTransferComponent } from './../pages/feed/transfer/modal-transfer/modal-transfer.component';
import { ModalDeleteAccountComponent } from './../pages/settings/modal-delete-account/modal-delete-account.component';
import { ModalOperatorComponent } from './../pages/settings/modal-operator/modal-operator.component';
import { ModalSelfEmployedCompanyComponent } from './../pages/settings/modal-self-employed-company/modal-self-employed-company.component';
import { SignupCompanyAddressComponent } from './../pages/signup-company/modal/signup-company-address/signup-company-address.component';
import { SignupBirthComponent } from './../pages/signup-new/modals/signup-birth/signup-birth.component';
import { SignupDocumentComponent } from './../pages/signup-new/modals/signup-document/signup-document.component';
import { SignupIndicatedComponent } from './../pages/signup-new/modals/signup-indicated/signup-indicated.component';
import { SignupNameComponent } from './../pages/signup-new/modals/signup-name/signup-name.component';
import { SignupPasswordComponent } from './../pages/signup-new/modals/signup-password/signup-password.component';
import { SignupPhoneComponent } from './../pages/signup-new/modals/signup-phone/signup-phone.component';
import { AddressComponent } from './address/address.component';
import { CreditsComponent } from './credits/credits.component';
import { ModalCreditsBlockedComponent } from './credits/modal-credits-blocked/modal-credits-blocked.component';
import { HeaderNameComponent } from './header-name/header-name.component';
import { HeaderSimpleComponent } from './header-simple/header-simple.component';
import { LogoComponent } from './logo/logo.component';
import { PrivacyNoticeComponent } from './privacy-notice/privacy-notice.component';
import { SearchSelectComponent } from './searchable-select/searchable-select.component';
import { ShowHidePasswordComponent } from './show-hide-password/show-hide-password.component';
import { TermsAcceptedComponent } from './terms-accepted/terms-accepted.component';
import { TermsCompanyComponent } from './terms-company/terms-company.component';
import { TermsComponent } from './terms/terms.component';
import { UserDataComponent } from './user-data/user-data.component';

@NgModule({
  declarations: [
    LogoComponent,
    HeaderNameComponent,
    HeaderSimpleComponent,
    UserDataComponent,
    AddressComponent,
    ModalMoreComponent,
    ModalTransferComponent,
    ModalOperatorComponent,
    ModalCashbackComponent,
    ModalCreditsBlockedComponent,
    ModalPayAddValueComponent,
    ModalReceiveBankComponent,
    ModalReceiveColappComponent,
    ModalReceiveLinkComponent,
    ModalReceiveTotemComponent,
    ModalReceiptComponent,
    ModalCashbackInfoComponent,
    ModalDeleteAccountComponent,
    ModalSelfEmployedCompanyComponent,
    ModalDetailsIndicatedComponent,
    ModalChargeAndPayComponent,
    CreditsComponent,
    SignupNameComponent,
    SignupBirthComponent,
    SignupDocumentComponent,
    SignupIndicatedComponent,
    SignupPasswordComponent,
    SignupPhoneComponent,
    TermsAcceptedComponent,
    TermsComponent,
    TermsCompanyComponent,
    PrivacyNoticeComponent,
    SignupCompanyAddressComponent,
    SignupCompanyConfigsComponent,
    SignupCompanyDataComponent,
    ShowHidePasswordComponent,
    SearchSelectComponent,
  ],
  providers: [Geolocation],
  exports: [
    LogoComponent,
    HeaderNameComponent,
    HeaderSimpleComponent,
    UserDataComponent,
    AddressComponent,
    ModalMoreComponent,
    ModalTransferComponent,
    CreditsComponent,
    SignupNameComponent,
    SignupBirthComponent,
    SignupDocumentComponent,
    SignupIndicatedComponent,
    SignupPasswordComponent,
    SignupPhoneComponent,
    TermsComponent,
    TermsCompanyComponent,
    PrivacyNoticeComponent,
    SignupCompanyAddressComponent,
    SignupCompanyConfigsComponent,
    SignupCompanyDataComponent,
    ShowHidePasswordComponent,
    SearchSelectComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule.forRoot(),
    PipesModule,
    CurrencyModule,
  ],
})
export class ComponentsModule {}
